import "lodash";
import { l, m, c, e, f, k, g, h, b, i, j, r, s, t, d } from "../CommonStringUtils-1580a6f6.js";
export {
  l as CommonStringUtils,
  m as CommonStringUtilsInstance,
  c as compareIgnoreCase,
  e as containsIgnoreCase,
  f as friendlyAssetName,
  k as getArticleText,
  g as getNewGuid,
  h as hashCode,
  b as includesIgnoreCase,
  i as isGuid,
  j as joinString,
  r as removeEmptyValues,
  s as strEndsWith,
  t as toLowerCaseArray,
  d as toLowerCaseDictionary
};
//# sourceMappingURL=CommonStringUtils.js.map
